import { gql, useQuery } from '@apollo/client'

import {
  ArtistDmRoomsConnectionFragmentDoc,
  ConsoleDmRoomsQuery,
  ConsoleDmRoomsQueryVariables,
} from '@/clients/utoniq-core/schema'
import { makeViewModel } from '@/core/architecture'
import { useCurrentUser } from '@/core/auth'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { user } = useCurrentUser()
  // artistDmRoomsクエリを実行しDMルーム一覧を取得
  const { data, loading, fetchMore } = useQuery<
    ConsoleDmRoomsQuery,
    ConsoleDmRoomsQueryVariables
  >(QUERY, {
    notifyOnNetworkStatusChange: true,
    variables: {},
  })

  return {
    state: {
      artistId: user?.uid ?? '',
      dmRooms: data?.artistDmRooms ?? null,
      loading,
      hasNextPage: !!data?.artistDmRooms?.pageInfo.hasNextPage,
    },
    actions: {
      /**
       * 次のページを取得する（無限スクロール時）
       */
      async onFetchMore() {
        await fetchMore({
          variables: {
            // 最後のカーソル位置から続き取得
            pageInput: { cursor: data?.artistDmRooms?.pageInfo.endCursor },
          },
        })
      },
    },
  }
})

/**
 * アーティスト用DMルーム一覧を取得するクエリ
 */
const QUERY = gql`
  query ConsoleDmRooms($pageInput: PageInput) {
    artistDmRooms(pageInput: $pageInput) {
      ...ArtistDmRoomsConnection
    }
  }
  ${ArtistDmRoomsConnectionFragmentDoc}
`
